export default __webpack_public_path__ + "static/media/cloud-2.6c0bcfb6.png";